var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 10C21.0894 11.7326 26.0418 12.1585 30.83 11.23C30.5177 8.60474 29.5135 6.10962 27.92 4H3.92002C2.8368 5.43831 2.02362 7.06128 1.52002 8.79C6.54103 7.83435 11.7269 8.2524 16.53 10Z",
    fill: "#F4801A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 12C11.5572 10.1923 6.17796 9.81131 1 10.9C1 11.27 1 12.63 1 13C1.07597 16.8202 2.6069 20.4673 5.28034 23.1971C7.95378 25.927 11.5682 27.5337 15.3859 27.6893C19.2036 27.845 22.9368 26.5379 25.8237 24.0348C28.7105 21.5317 30.5333 17.0213 30.92 13.22C26.1036 14.1673 21.1181 13.7446 16.53 12ZM17.3 23.27C15.0424 23.1464 12.8867 22.2898 11.16 20.83L6.92 23.5V15.5L11.16 18.17C12.8867 16.7103 15.0424 15.8536 17.3 15.73C21.51 15.73 24.92 19.5 24.92 19.5C24.92 19.5 21.51 23.27 17.3 23.27Z",
    fill: "#F4801A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/LogoMark.85b802f845b2837cebd7eaee34c41a01.svg";
export { ForwardRef as ReactComponent };